import { useState, useEffect } from 'react';
import { UserAuth } from '../context/AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';
import { getFirestore, collection, getDocs, addDoc, setDoc, doc } from 'firebase/firestore';
import {db} from '../firebase-config';

const useForm = (callback, validate) => {
  const [values, setValues] = useState({
    username: '',
    email: '',
    password: '',
    password2: '',
    account: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { createUser } = UserAuth();
  const { currentUser } = UserAuth();
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };
  
  async function fetchData() {
    if (values.password != values.password2) {
      setErrors(validate(values));
      return
    }
    try {
      await createUser(values.email, values.password);
      setIsSubmitting(true);
      setDoc(doc(db, "accounts", currentUser.uid), { type: values.account, user: {userID: currentUser.uid, email: values.email, userName: values.username, firstname: '', lastname: ''}, contactInfo: {city: ' ', email: values.email, phoneNumber: ' ', state: ' ', street: ' ', zipCode: ' '} } )

      // await setDoc(doc(db, "accounts", currentUser.uid), { type: values.account, user: {userID: currentUser.uid, email: values.email, userName: values.username, firstname: '', lastname: ''} } )
      navigate('/account');
      console.log(isSubmitting)
    } catch (e) {
      console.log(e.message);
      setErrors(validate(values));
      if (e.message == 'Firebase: Error (auth/email-already-in-use).') {
        setErrors(validate('duplicate email'));
      }
    }
  }

  const handleSubmit = async (e) =>  {
    e.preventDefault();
    fetchData();
  };

  useEffect(
    () => {
      if (Object.keys(errors).length === 0 && isSubmitting) {
        console.log(createUser);
        if (values.account == 'Adopter') {
          setDoc(doc(db, "accounts", currentUser.uid), { type: values.account, user: {userID: currentUser.uid, email: values.email, userName: values.username, firstname: '', lastname: ''}, contactInfo: {city: ' ', email: values.email, phoneNumber: ' ', state: ' ', street: ' ', zipCode: ' '} } )
        } else if (values.account == 'Shelter') {
          setDoc(doc(db, "accounts", currentUser.uid), { type: values.account, user: {userID: currentUser.uid, email: values.email, userName: values.username}, contactInfo: {city: ' ', email: values.email, phoneNumber: ' ', state: ' ', street: ' ', zipCode: ' '}, shelter: {name: ' ', website: ' '} } )
        }
        navigate('/account');
      }
    },
    [errors]
  );

  return { handleChange, handleSubmit, values, errors };
};

export default useForm;